import {
  Col,
  DatePicker,
  Row,
  Tabs,
  message,
  Switch,
  InputNumber,
  Button,
  Card,
  Form,
  Input,
  Typhography,
} from "antd";

import InfoIcon from "@material-ui/icons/Info";
import { Divider, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Select } from "antd";
import { addMenu, fetchOneMenu, updateMenu } from "redux/features/menu";
import { MyEditor } from "../../../components/Editor";
import ImageUploader from "components/shared-components/ImageUploader";
import moment from "moment";
import { fetchAllMenuType } from "redux/features/menuType";

const { TextArea } = Input;

const selectStyle = {
  width: "100%",
  backgroundColor: "white",
};

const rules = [
  {
    required: true,
    message: "Wajib Diisi!",
  },
];

export const ADD_SIDANG = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const location = useLocation();

  const [idBody, setIdBody] = useState("");
  const [enBody, setEnBody] = useState("");
  const [subcategories, setSubcategories] = useState();
  const [tags, setTags] = useState();
  const [imgUrl, setImgUrl] = useState("");
  const [imgUrlDisplay, setImgUrlDisplay] = useState("");
  const [menuTypes, setMenuTypes] = useState([]);

  const onFinish = (values) => {
    if (location?.state?.id) {
      updateData(values);
    } else {
      createData(values);
    }
  };
  const { Title } = Typography;

  const createData = async (values) => {
    console.log("create data :", values);
    try {
      // YYYY-MM-DDTHH:mm
      await dispatch(
        addMenu({
          ...values,
          rating: Number(values.rating),
          normal_price: Number(values.normal_price),
          discount_price: Number(values.discount_price),
          date: moment(values.date).format("YYYY-MM-DDTHH:mm"),
          image_url: imgUrl ? imgUrl : undefined,
        })
      ).unwrap();
      history.push("/app/menu");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  // {
  //   "name": "Team Meeting",
  //   "location": "Conference Room B, Floor 2",
  //   "date": "2025-01-10T10:30"
  // }

  const updateData = async (values) => {
    try {
      await dispatch(
        updateMenu({
          ...values,
          normal_price: Number(values.normal_price),
          discount_price: Number(values.discount_price),
          id: location?.state?.id,
          date: moment(values.date).format("YYYY-MM-DDTHH:mm"),
          image_url: imgUrl ? imgUrl : undefined,
        })
      ).unwrap();
      history.push("/app/menu");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getDataById = async (id) => {
    try {
      const res = await dispatch(fetchOneMenu(id)).unwrap();
      form.setFieldsValue({
        ...res.data,
      });
      setImgUrlDisplay(res.data.image_url);
      setEnBody(res?.data.body_en);
      setIdBody(res?.data.body);
      //   setImgUrl(data.data.thumbnail);
    } catch (err) {
      console.log(err);
    }
  };

  const getMenuTypes = async () => {
    try {
      const res = await dispatch(fetchAllMenuType()).unwrap();

      const mapped = res.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setMenuTypes(mapped);
    } catch (error) {
      console.error("Failed to fetch menu types", error);
    }
  };

  const handleImageUpload = (info) => {
    const { status, response } = info.file;
    if (status === "uploading") {
      return;
    }
    if (status === "done") {
      setImgUrl(response.data.secure_url);
    }
  };

  useEffect(() => {
    console.log("loc: ", location?.state?.id);
    if (location?.state?.id) {
      getDataById(location?.state?.id);
    }
    getMenuTypes();
  }, []);

  const layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 6 },
      lg: { span: 5 },
      xl: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 18 },
      lg: { span: 19 },
      xl: { span: 20 },
    },
  };

  const menuTypesDummy = [
    { label: "Coffee", value: 1 },
    { label: "Non-Coffee", value: 2 },
    { label: "Snack", value: 3 },
  ];

  return (
    <>
      {/* Title */}
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Title level={2}>Tambah/Update Menu</Title>
          <p>Tambah menu dan update menu</p>
        </Col>
      </Row>
      {/* Form */}
      <Row gutter={24}>
        <Col xs={18} sm={18} md={18} lg={18} gap={3}>
          <Card>
            <Title level={4}>Informasi Produk</Title>
            <Form
              name="basic"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              labelAlign="right"
              {...layout}
            >
              <Form.Item
                label="Menu"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Kolom wajib diisi!",
                  },
                ]}
              >
                <Input showCount maxLength={255} placeholder="Mohon masukkan" />
              </Form.Item>

              <Form.Item
                name="menu_type_id"
                label="Tipe Menu"
                rules={[{ required: true, message: "Pilih tipe menu!" }]}
              >
                <Select placeholder="Silahkan pilih">
                  {menuTypes.map((type) => (
                    <Select.Option key={type.value} value={type.value}>
                      {type.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Deskripsi"
                name="description"
                rules={[
                  {
                    required: true,
                    message: "Kolom wajib diisi!",
                  },
                ]}
              >
                <TextArea showCount maxLength={100} />
              </Form.Item>

              <Divider />
              <Typography.Title level={4}>Informasi Penjualan</Typography.Title>
              <Form.Item
                label="Harga Normal"
                name="normal_price"
                tooltip={{
                  title: "Tooltip with customize icon",
                  icon: <InfoIcon />,
                }}
                rules={[
                  {
                    type: "number",
                    min: 1000,
                    message: "Harga minimal Rp 1.000",
                  },
                  {
                    type: "number",
                    max: 100000,
                    message: "Harga max Rp 100.000",
                  },
                  {
                    required: true,
                    message: "Kolom wajib diisi!",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="Mohon masukkan"
                  formatter={(value) =>
                    value.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }
                  parser={(value) => value?.replace(/\D/g, "")}
                />
              </Form.Item>

              <Form.Item
                label="Presentase Diskon"
                name="discount_percentage"
                rules={[
                  {
                    type: "number",
                    min: 1,
                    message: "Presentase diskon minimal 1% ",
                  },
                  {
                    type: "number",
                    max: 100,
                    message: "Presentase diskon  maksimal 100%",
                  },
                ]}
              >
                <InputNumber />
              </Form.Item>

              <Form.Item
                label="Harga Diskon"
                name="discount_price"
                rules={[
                  {
                    type: "number",
                    min: 1000,
                    message: "Harga minimal Rp 1.000",
                  },
                  {
                    type: "number",
                    max: 100000,
                    message: "Harga max Rp 100.000",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="Mohon masukkan"
                  formatter={(value) =>
                    value.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }
                  parser={(value) => value?.replace(/\D/g, "")}
                />
              </Form.Item>

              {/* <Form.Item
                label="Rating"
                name="rating"
                rules={[
                  {
                    type: "number",
                    min: 1,
                    message: "Rating minimal 1",
                  },
                  {
                    type: "number",
                    max: 5,
                    message: "Rating max 5",
                  },
                ]}
              >
                <InputNumber max={5} />
              </Form.Item> */}

              <Form.Item label="Menu Baru?" name="is_new">
                <Switch />
              </Form.Item>

              <Form.Item label="Sedang Diskon?" name="is_sale">
                <Switch />
              </Form.Item>

              <Form.Item wrapperCol={{ span: 24 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
        {/* Image */}
        <Col xs={6} sm={6} md={6} lg={6} gap={3}>
          {/* <Card>
            <img src={imgUrlDisplay} style={{ width: "100%" }}></img>
            <br></br>
            <h3>Ubah Foto Menu</h3>
            <Form.Item label="Foto Menu" name="photo">
              <ImageUploader imageUrl={imgUrl} onChange={handleImageUpload} />
            </Form.Item>
          </Card> */}
          <Card title="Ubah Foto Menu">
            <Form.Item label="Foto Menu" name="photo">
              <ImageUploader imageUrl={imgUrl} onChange={handleImageUpload} />
            </Form.Item>

            {/* Tampilkan preview jika ada */}
            {imgUrlDisplay && (
              <img
                src={imgUrlDisplay}
                alt="Preview Foto Menu"
                style={{ width: "100%", borderRadius: 8, marginTop: 8 }}
              />
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ADD_SIDANG;
